// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Clear = React.forwardRef(function Clear(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></SvgIcon>;
});
export default Clear;
